<main>
  <fr8bot-web-entity-home-section
    [videoSrc]="videos.carrier"
    posterSrc="/assets/image/web-carrier-video.webp"
  >
    <ng-container title>
      {{ 'landing.drivers.home.title1' | translate }}.
      <span class="web-title-highlight"
        >{{ 'landing.drivers.home.titleHighlight' | translate }}.</span
      >
    </ng-container>

    <ng-container description>
      {{ 'landing.drivers.home.description' | translate }}
    </ng-container>

    <ng-container actions>
      <fr8bot-ui-button
        type="primaryCut"
        size="large"
        data-testid="landing-drivers-apply"
        (click)="landing.openCarrierCabinet()"
      >
        {{ 'landing.drivers.home.applyToDrive' | translate }}
        <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
      </fr8bot-ui-button>

      <fr8bot-ui-button
        type="secondary"
        size="large"
        data-testid="landing-drivers-see-loads"
        (click)="landing.scrollToAnchor('web-loads-map-id')"
      >
        {{ 'landing.drivers.home.seeLoads' | translate }}
      </fr8bot-ui-button>
    </ng-container>

    <ng-container label>{{ 'landing.drivers.home.label' | translate }}</ng-container>
  </fr8bot-web-entity-home-section>

  <fr8bot-web-loads-map (openCarrierCabinet)="landing.openCarrierCabinet()" />

  <fr8bot-web-parallax-bg>
    <div class="web-section-shadow web-section-shadow--top"></div>

    <div class="live-capacity-section__header">
      <span class="web-section-label">{{ 'landing.drivers.whyDrive.label' | translate }}</span>

      <h2 class="live-capacity-section__header-title">
        {{ 'landing.drivers.whyDrive.title' | translate }}
      </h2>
    </div>

    <div class="live-capacity-section__content">
      <div class="live-capacity-section__content-cards">
        <fr8bot-web-card-v-1
          [title]="'landing.drivers.whyDrive.cards.sameDayPay.title' | translate"
          [description]="'landing.drivers.whyDrive.cards.sameDayPay.description' | translate"
          icon="web-revenue"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.drivers.whyDrive.cards.terms.title' | translate"
          [description]="'landing.drivers.whyDrive.cards.terms.description' | translate"
          icon="web-choose"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.drivers.whyDrive.cards.deadhead.title' | translate"
          [description]="'landing.drivers.whyDrive.cards.deadhead.description' | translate"
          icon="web-path"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.drivers.whyDrive.cards.business.title' | translate"
          [description]="'landing.drivers.whyDrive.cards.business.description' | translate"
          icon="web-business"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.drivers.whyDrive.cards.support.title' | translate"
          [description]="'landing.drivers.whyDrive.cards.support.description' | translate"
          icon="web-support"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.drivers.whyDrive.cards.onboarding.title' | translate"
          [description]="'landing.drivers.whyDrive.cards.onboarding.description' | translate"
          icon="web-checkmark-approved"
        />
      </div>

      <fr8bot-ui-button
        class="live-capacity-section__content-button"
        data-testid="landing-drivers-why-cta"
        type="primaryCut"
        size="large"
        (click)="landing.openCarrierCabinet()"
      >
        {{ 'landing.drivers.whyDrive.button' | translate }}
        <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
      </fr8bot-ui-button>
    </div>
  </fr8bot-web-parallax-bg>

  <div class="divider divider--size-large divider--color-black"></div>
</main>
